import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { webSocket, WebSocketSubject, WebSocketSubjectConfig } from 'rxjs/webSocket';
import * as converter from 'xml-js';

import { calypsoData } from '../../model/calypso-data.model';
import { CalypsoEvent } from '../../model/caypso-event.model';
import { UserService } from '../auth/user.service';
import { ConfigService } from '../config/config.service';


@Injectable({providedIn: 'root'})
export class CalypsoService implements OnDestroy {
    isActive = false;
    isLoggedInCalypso = false;
    calypsoData: calypsoData = null;
    onConnect: EventEmitter<void> = new EventEmitter<void>();
    onCalling: EventEmitter<CalypsoEvent> = new EventEmitter<CalypsoEvent>();
    eventNumber = 0;
    wsSessionId = "";
    calypsowsUrl = "";
    apiUrl = "";
    private debugMode = false;
    private webSocket: WebSocketSubject<any>;
    private webSocketConfig: WebSocketSubjectConfig<any>;
    private parser = new DOMParser();

    constructor(private httpClient: HttpClient,
        private userService: UserService,
        private configService: ConfigService) {
        this.calypsowsUrl = this.configService.get("calypsoWebsocketUrl") as string;
        this.apiUrl = this.configService.get("apiURL") as string;
        this.webSocketConfig = {
            url: this.calypsowsUrl + "/all",
            deserializer: (e) => e.data
        };
    }

    ngOnDestroy() {
        if (this.debugMode) {
            console.log('Destruyendo servicio y desconectando de Calypso.');
        }
        if (this.isActive === true) {
            this.webSocket.unsubscribe();
        }
    }

    setDebugMode(mode: boolean) {
        this.debugMode = mode;
    }

    connectWs() {
        if (this.debugMode === true) {
            console.log("URLServidor = " + this.calypsowsUrl);
            console.log("Estamos monitorizando al operador de Calypso " + this.calypsoData.userId);
            console.log("Antes de suscribirse a los eventos de Calypso.");
            this.webSocket = webSocket(this.webSocketConfig);
            console.log("Se ha conectado al servidor de Calypso.");
            this.subscribeToEvents();
            console.log("Suscritos a los eventos de Calypso.");
        } else {
            this.webSocket = webSocket(this.webSocketConfig);
            this.subscribeToEvents();
        }
    }

    private subscribeToEvents() {
        if (this.debugMode) {
            console.log("Suscribiéndose a mensajes y errores.");
        }
        this.webSocket.subscribe(
            (data: any) => {
                console.log(data);
                const json = converter.xml2json(data);
                const response = JSON.parse(json);
                this.eventNumber++;
                this.handleEvent(response.elements[0].attributes.name,
                    response.elements[0].attributes.result,
                    response.elements[0].attributes.ori,
                    response.elements[0].attributes.userId,
                    response.elements[0].attributes.cause,
                    response.elements[0].attributes.causeDescription,
                    response.elements[0].attributes.contactId,
                    this.getTerminalFromJson(response),
                    this.getConnectionIdFromJson(response),
                    this.getWsSessionId(response));
            },
            (error: any) => {
                console.log('Error en Calypso WS: ', error);
            },
            () => {
                console.log('Conexión interrumpida en WS.');
            }
        );
    }

    getWsSessionId(json: any): string {
        let wsSessionId = "";
        if (json.elements != null && json.elements.length > 0) {
            if (json.elements[0].attributes != null) {
                wsSessionId = json.elements[0].attributes.wsSessionId;
            }
        }
        return wsSessionId;
    }

    getTerminalFromJson(json: any): string {
        let terminal = "";
        if (json.elements != null && json.elements.length > 0) {
            if (json.elements[0].elements != null && json.elements[0].elements.length > 0) {
                if (json.elements[0].elements[0].elements != null && json.elements[0].elements[0].elements.length > 1) {
                    if (json.elements[0].elements[0].elements[1].elements != null && json.elements[0].elements[0].elements[1].elements.length > 0) {
                        terminal = json.elements[0].elements[0].elements[1].elements[0].attributes.dn;
                    }
                }
            }
        }
        return terminal;
    }

    getConnectionIdFromJson(json: any): string {
        let connection = "";
        if (json.elements != null && json.elements.length > 0) {
            if (json.elements[0].elements != null && json.elements[0].elements.length > 1) {
                if (json.elements[0].elements[1].elements != null && json.elements[0].elements[1].elements.length > 0) {
                    if (json.elements[0].elements[1].elements[0].elements != null && json.elements[0].elements[1].elements[0].elements.length > 0) {
                        if (json.elements[0].elements[1].elements[0].elements[0].elements != null && json.elements[0].elements[1].elements[0].elements[0].elements.length > 0) {
                            connection = json.elements[0].elements[1].elements[0].elements[0].elements[0].attributes.id;
                        }
                    }
                }
            }
        }
        return connection;
    }

    disconnectWs() {
        if (this.debugMode) {
            console.log('Se ha desconectado del WebSocket.');
        }
        this.logoutCalypso(true);
    }

    handleEvent(name: string, result: string, originNumber: string,
        userId: string, cause: string, causeDescription: string,
        contactId: string, terminal: string, connection: string, wsSessionId = "") {
        if (name === "incomingcall") {
            if (this.debugMode) console.log("#" + this.eventNumber, "Al ser un evento incomingcall se va a procesar.");
            if (result === "ok") {
                if (this.debugMode) console.log("#" + this.eventNumber, "El resultado del evento es OK, significa que un operador ha descolgado una llamada.");
                if (this.calypsoData.userId.length > 0) {
                    if (this.debugMode) console.log("#" + this.eventNumber, "Estamos monitorizando al operador " + this.calypsoData.userId + ": Vamos a comprobar si es el operador que ha descolgado.");
                    if (this.calypsoData.userId === userId) {
                        if (this.debugMode) console.log("#" + this.eventNumber, "El operador monitorizado es quien ha descolgado la llamada por lo que almacenamos el número de teléfono para Hipatia.");
                        if (this.debugMode) console.log("#" + this.eventNumber, "El operador ha descolgado el teléfono para atender al número " + originNumber);
                        this.onCalling.emit(new CalypsoEvent(true, originNumber, userId, cause, causeDescription, contactId, terminal, connection, "Llamada en curso", "incoming"));
                    } else {
                        if (this.debugMode) console.log("#" + this.eventNumber, "El operador monitorizado NO ES quien ha descolgado la llamada. No hacemos nada.");
                        this.onCalling.emit(new CalypsoEvent(false, "", userId, cause, causeDescription, contactId, terminal, connection, "", "incoming"));
                    }
                } else {
                    if (this.debugMode) console.log("#" + this.eventNumber, "Estamos monitorizando a todos los operadores por lo que almacenamos el número de teléfono para Hipatia.");
                    if (this.debugMode) console.log("#" + this.eventNumber, "El operador ha descolgado el teléfono para atender al número " + originNumber);
                    this.onCalling.emit(new CalypsoEvent(false, "", userId, cause, causeDescription, contactId, terminal, connection, "", "incoming"));
                }
            } else {
                //if (this.debugMode) console.log("#" + this.eventNumber, "El resultado del evento no es ok sino " + result + " por lo que no se hace nada.");
                if (this.debugMode) console.log("#" + this.eventNumber, "El resultado del evento no es ok sino " + result + " por lo que se va a enviar señal de finalizacion de llamada.");
                this.onCalling.emit(new CalypsoEvent(false, "", userId, cause, causeDescription, contactId, terminal, connection, "", "incoming"));
            }
        } else if (name === "ring") {
            let event;
            if (result === "initiated") {
                event = new CalypsoEvent(true, originNumber, userId, cause, causeDescription, contactId, terminal, connection, "Llamada entrante")
                if (this.debugMode) console.log("#" + this.eventNumber, "Está sonando una llamada entrante.");
                if (this.debugMode) console.log(event);
                //this.onCalling.emit(new CalypsoEvent(true, originNumber, userId, cause, causeDescription, contactId, terminal, connection, "Llamada entrante"));
                this.onCalling.emit(event);
            } else if (result === "ok") {
                if (this.debugMode) console.log("#" + this.eventNumber, "Un operador ha respondido una llamada entrante.");
                this.onCalling.emit(new CalypsoEvent(true, "", userId, cause, causeDescription, contactId, terminal, connection, "", "incoming"));
            } else if (result === "failed") {
                if (this.debugMode) console.log("#" + this.eventNumber, "No se ha atendido la llamada entrante.");
                this.onCalling.emit(new CalypsoEvent(false, "", userId, cause, causeDescription, contactId, terminal, connection, "", "incoming"));
            } else {
                if (this.debugMode) console.log("#" + this.eventNumber, "No se ha detectado 'result' en este evento, result = " + result + ".");
            }
        } else if (name === "makecall") {
            if (this.debugMode) console.log("#" + this.eventNumber, "Un operador está haciendo una llamada.");
            if (this.calypsoData.userId === userId) {
                if (this.debugMode) console.log("#" + this.eventNumber, "El operador monitorizado es el que está haciendo la llamada.");
                if (result === "initiated") {
                    if (this.debugMode) console.log("#" + this.eventNumber, "Se está marcando el número de teléfono de destino.");
                    this.onCalling.emit(new CalypsoEvent(true, originNumber, userId, cause, causeDescription, contactId, terminal, connection, "Llamando", "outgoing"));
                } else if (result === "ring") {
                    if (this.debugMode) console.log("#" + this.eventNumber, "Está sonando el número de teléfono de destino.");
                    this.onCalling.emit(new CalypsoEvent(true, originNumber, userId, cause, causeDescription, contactId, terminal, connection, "Llamando", "outgoing"));
                } else if (result === "ok") {
                    if (this.debugMode) console.log("#" + this.eventNumber, "El destinatario ha descolgado el teléfono.");
                    this.onCalling.emit(new CalypsoEvent(true, originNumber, userId, cause, causeDescription, contactId, terminal, connection, "Llamada en curso", "outgoing"));
                } else if (result === "failed") {
                    if (cause == null || cause.length === 0) {
                        if (this.debugMode) console.log("#" + this.eventNumber, "El operador ha cancelado la llamada.");
                        this.onCalling.emit(new CalypsoEvent(false, "", userId, cause, causeDescription, contactId, terminal, connection, "", "outgoing"));
                    } else {
                        if (this.debugMode) console.log("#" + this.eventNumber, "No ha sido posible contactar con el destinatario", "Llamada saliente fallida.");
                        this.onCalling.emit(new CalypsoEvent(false, "", userId, cause, causeDescription, contactId, terminal, connection, "", "outgoing"));
                    }
                } else {
                    if (this.debugMode) console.log("#" + this.eventNumber, "No se ha detectado 'result' en este evento, result = " + result + ".");
                }
            }
        } else if (name === "connectionclear") {
            if (result === "ok") {
                if (this.debugMode) console.log("#" + this.eventNumber, "Se ha colgado una llamada.");
                if (this.calypsoData.userId.length > 0) {
                    if (this.debugMode) console.log("#" + this.eventNumber, "Estamos monitorizando al operador " + this.calypsoData.userId + ": Vamos a comprobar si es el operador que ha colgado.");
                    if (this.calypsoData.userId === userId) {
                        if (this.debugMode) console.log("#" + this.eventNumber, "El operador monitorizado es quien ha colgado la llamada por lo que actualizamos estado.");
                        this.onCalling.emit(new CalypsoEvent(false, "", userId, cause, causeDescription, contactId, terminal, connection, "", "both"));
                    } else {
                        if (this.debugMode) console.log("#" + this.eventNumber, "El operador monitorizado NO ES quien ha descolgado la llamada. No hacemos nada.");
                    }
                } else {
                    if (this.debugMode) console.log("#" + this.eventNumber, "El operador monitorizado NO ES quien ha descolgado la llamada. No hacemos nada.");
                }
            } else {
                if (this.debugMode) console.log("#" + this.eventNumber, "No se ha detectado 'result' en este evento, result = " + result + ".");
            }
        } else if (name == "open") {
            if (this.debugMode) console.log("#" + this.eventNumber, "Se ha conectado al webSocket con el wsSesssionId: " + wsSessionId);
            this.wsSessionId = wsSessionId;
        } else {
            if (this.debugMode) console.log("#" + this.eventNumber, "No se ha detectado 'name' en este evento, name = " + name + ".");
        }
    }

    /**
     * @param user id de usuario
     * @param contact id de contacto que se quiere responder
     * @param terminal id de terminal con el que se atenderá la llamada
     */
    responseCall(user: string, contact: number, terminal: string) {
        return this.httpClient.get(
            this.calypsowsUrl + "cm/action/responder?"
            + "usuario=" + user
            + "&contacto=" + contact
            + "&terminal=" + terminal,
            {
                responseType: 'text'
            }
        );
    }

    /**
     * @param user id de usuario
     * @param connection id de conexion
     */
    disconnectCall(user: string, connection: string) {
        return this.httpClient.get(
            this.calypsowsUrl + "cm/action/desconectar?"
            + "usuario=" + user
            + "&conexion=" + connection
        );
    }

    /**
     * @param user id de usuario
     * @param terminal Terminal por el cual queremos realizar la llamada (atributo dn en el terminal del usuario)
     * @param destination numero destino
     * @param resource id de recurso para usar. (0 es el recurso virtual automático y el -1 es el recurso interno)
     */
    makeCall(user: string, terminal: string, destination: string, resource: number) {
        return this.httpClient.get(
            this.calypsowsUrl + "cm/action/marcar?"
            + "usuario=" + user
            + "&terminal=" + terminal
            + "&destino=" + destination
            + "&recurso=" + resource,
            {
                responseType: 'text'
            }
        );
    }



    /**
     * @param user Nombre de usuario (login).
     * @param password Contraseña sin espacios ni al principio ni al final. Dependiendo del valor de encryptedpass puede ser un texto en formato plano, o una cadena SHA512 en formato hexadecimal.
     * @param userLocation Localización según aparece configurada en Calypso para la asignación de dispositivo.
     * @param client Sólo aplicable para clientes agregadores que funcionan en modo third-party, esto es, usando el websocket general “all” (por ejemplo, clientes web). 
     *               Este parámetro especifica un ID de cliente y todos los usuarios logados desde ese cliente serán asociados al mismo. 
     *               Si no se especifica, se asume una petición login para cliente first-party (que posteriormente abrirá websocket de usuario).
     * @param encryptedpass Valor boolean, por defecto si no se indica se toma valor true.
     *                        True: Indica que la contraseña introducida en el campo password tiene un formato SHA-512.
     *                        False: Indica que la contraseña introducida en el campo password no tiene encriptación.
     *                      La motivación para realizar un envío de contraseña sin encriptación es en sistema con autenticación de terceros , como por ejemplo LDAP/DA.
     */
    loginCalypso() {
        const body = new HttpParams()
            .set('username', this.calypsoData.userId)
            .set('password', this.calypsoData.password)
            .set('userLocation', this.calypsoData.userLocation)
            .set('client', "hipatiaWeb")
        this.httpClient.put(
            this.calypsowsUrl + "user/action/login",
            // No se puede poner como un objeto directamente porque lo trata como un json. 
            // Se tiene que crear un objeto HttpParams.
            body,
            {
                headers: new HttpHeaders(
                    {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                ),
                responseType: 'text'
            }
        ).subscribe(
            (response: any) => {
                if (this.debugMode) {
                    console.log("Se ha iniciado sesión en calypso con el siguien usuario: " + this.calypsoData.userId);
                }
                this.isLoggedInCalypso = true;
            },
            (error: any) => {
                console.log(error);
            }
        );
    }

    /**
     * @param usuario Id de usuario
     * @param wsSessionId Sólo aplicable para clientes first-party que quieren deslogarse de un websocket concreto. Se pasa el id 
                          del websocket sobre la cual queremos realizar el fin de la sesión. Si el usuario está logado en otra 
                          sesión u otro cliente, se mantendrá logado. Si no se especifica y hay más de un websocket cliente, 
                          esta petición no tendrá efecto
     * @param client Sólo aplicable para clientes agregadores que funcionan en modo third-party, esto es, usando el 
                    websocket general “all”. De forma similar al parámetro wsSessionId, este parámetro especifica un ID 
                    de cliente para el cual queremos deslogar el usuario. Si el usuario está logado en otro cliente, se 
                    mantendrá logado.
     * @param force Con true, el usuario es desconectado de todas las conexiones (web y websocket)
     * @returns El logout del usuario sobre el id de websocket supondrá el cierre inmediato del mismo con código 1000 (normal closure).
     */
    //logoutCalypso(usuario: string, client: string = "hipatiaWeb", force: boolean = false, wsSessionId: string = "") {
    logoutCalypso(disconnectAfter = false) {
        if (!this.isActive) return;
        let url = this.calypsowsUrl + "user/action/logout" + "?usuario=" + this.calypsoData.userId;
        url += (this.wsSessionId != "" || this.wsSessionId != null || this.wsSessionId != undefined) ? "&wsSessionId=" + this.wsSessionId : "";
        url += "&client=hipatiaWeb";
        console.log(url);
        this.httpClient.get(url).subscribe(
            (response: any) => {
                if (this.debugMode) {
                    console.log("El usuario " + this.calypsoData.userId + " ha cerrado sesión en calypso");
                }
                this.isLoggedInCalypso = false;
                if (disconnectAfter) {
                    this.webSocket.unsubscribe();
                }
            },
            (error: any) => {
                console.log(error);
            }
        );
    }

    getCalypsoData() {
        return this.httpClient.get(
            this.apiUrl + "Calypso/CalypsoData",
            {
                headers: new HttpHeaders(
                    {
                        'Content-Type': 'application/json',
                        'Token': this.userService.currentUser.lastToken
                    }
                )
            }
        )
    }

    postCalypsoTable(name: string, result: string, originNumber: string, userId: string, cause: string, causeDescription: string) {
        return this.httpClient.post(
            this.apiUrl + "Calypsotables/Post",
            {
                result: result == null ? "" : result,
                name: name == null ? "" : name,
                originNumber: originNumber == null ? "" : originNumber,
                cause: cause == null ? "" : cause,
                casuseDescription: causeDescription == null ? "" : causeDescription,
                sequence: this.eventNumber,
                description: userId == null ? "" : userId
            },
            {
                headers: new HttpHeaders(
                    {
                        'Content-Type': 'application/json',
                        'Token': this.userService.currentUser.lastToken
                    }
                )
            }
        );
    }
}